
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAllocatorProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allocatorProfileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"section"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aumRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employerType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fundManager"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bio"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"executives"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"investmentCriteria"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAllocatorProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allocatorProfileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocatorProfileId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"section"},"value":{"kind":"Variable","name":{"kind":"Name","value":"section"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"aumRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aumRange"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"employerType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employerType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"location"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fundManager"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fundManager"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"bio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bio"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"executives"},"value":{"kind":"Variable","name":{"kind":"Name","value":"executives"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"investmentCriteria"},"value":{"kind":"Variable","name":{"kind":"Name","value":"investmentCriteria"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allocatorProfile"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AllocatorProfileCard"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AllocatorProfileExecutiveManagement"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AllocatorProfileInvestmentPreferences"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"investmentCriteria"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":988}};
    doc.loc.source = {"body":"#import '../fragments/AllocatorProfileCard.graphql'\n#import '../fragments/AllocatorProfileSection/AllocatorProfileExecutiveManagement.graphql'\n#import '../fragments/AllocatorProfileSection/AllocatorProfileInvestmentPreferences.graphql'\n\nmutation UpdateAllocatorProfile(\n  $allocatorProfileId: ID!\n  $section: String!\n  $aumRange: String\n  $employerType: String\n  $location: String\n  $fundManager: String\n  $bio: String\n  $executives: String\n  $investmentCriteria: String\n) {\n  updateAllocatorProfile(\n    input: {\n      allocatorProfileId: $allocatorProfileId\n      section: $section\n      aumRange: $aumRange\n      employerType: $employerType\n      location: $location\n      fundManager: $fundManager\n      bio: $bio\n      executives: $executives\n      investmentCriteria: $investmentCriteria\n    }\n  ) {\n    allocatorProfile {\n      ...AllocatorProfileCard\n      ...AllocatorProfileExecutiveManagement\n      ...AllocatorProfileInvestmentPreferences\n      investmentCriteria\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('../fragments/AllocatorProfileCard.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../fragments/AllocatorProfileSection/AllocatorProfileExecutiveManagement.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../fragments/AllocatorProfileSection/AllocatorProfileInvestmentPreferences.graphql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["UpdateAllocatorProfile"] = oneQuery(doc, "UpdateAllocatorProfile");
        
